// extracted by mini-css-extract-plugin
module.exports = {"privacy-page":"styles_privacy-page__2FZ74","content":"styles_content__r_xxv","last-modified":"styles_last-modified__X48Xi"};